import React, { useState } from 'react';
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from '@mui/material';
import { WorkflowObject } from '../api/workflowTypes';
import { Localized } from '@fluent/react';

interface WorkflowObjectSelectProps {
  defaultValue?: WorkflowObject | '';
  required?: boolean;
  onChange?: (value: WorkflowObject) => void;
}

export const WorkflowObjectSelect: React.FC<WorkflowObjectSelectProps> = ({
  defaultValue = '',
  required = false,
  onChange,
}) => {
  const [selected, setSelected] = useState<WorkflowObject | ''>(defaultValue);

  const handleChange = (event: SelectChangeEvent) => {
    const value = event.target.value as WorkflowObject;
    setSelected(value);
    onChange?.(value);
  };

  return (
    <FormControl fullWidth required={required} error={required && selected === ''}>
      <InputLabel shrink id="workflow-object-label">Typ obiektu</InputLabel>
      <Select
        labelId="workflow-object-label"
        label={<Localized id="workflow-object-label"><span>Typ obiektu</span></Localized>}
        value={selected}
        onChange={handleChange}
        displayEmpty
      >
        {Object.values(WorkflowObject).map((obj) => (
          <MenuItem key={obj} value={obj}>
            {obj}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
